
/**
 * @function
 * Create an EIM string from a list of EIM ConfigurationCodes
 * @param {string[]} selectedEimCodes
 */
export const createEim = (selectedEimCodes: string[]) => {
  return selectedEimCodes.map((code) => {
    const codeSplit = code.split('_');
    return codeSplit[1] === 'STD' ? '-' : codeSplit[1];
  }).join('');
}
